module.exports = __webpack_public_path__ + "img/journals-active.dfbbf012.svg";